<template>
  <v-row justify="center">
    <v-dialog v-model="open" persistent width="700px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="ml-2 text--subtitle">
            {{
              type === 'storage'
                ? $t('message.usageLimitTitle')
                : $t('message.usageLimitTitleTraffic')
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <span v-if="type === 'storage'">
            {{
              $t('message.warningLimitUsage').replace(
                'XXX',
                calcMegabytes(totalStorage, 'MB', 'GB', true)
              )
            }}
          </span>
          <span v-else>
            {{ $t('message.pages.usageLimitModal.cardText1') }}
            <button
              type="button"
              class="primary--text"
              @click="openHelpTrafficPage"
            >
              {{ $t('message.pages.usageLimitModal.cardText2') }}
            </button>
            {{
              hasPosPaidTraffic
                ? $t('message.pages.usageLimitModal.cardText3withPosTraffic')
                    .replace(
                      'YYY',
                      calcMegabytes(usedTraffic, 'MB', 'GB', true)
                    )
                    .replace(
                      'XXX',
                      calcMegabytes(totalTraffic, 'MB', 'GB', true)
                    )
                    .replace('XXXX', posPaidTrafficAddonValue)
                : $t('message.pages.usageLimitModal.cardText3')
                    .replace(
                      'XXX',
                      calcMegabytes(usedTraffic, 'MB', 'GB', true)
                    )
                    .replace(
                      'XXXX',
                      calcMegabytes(totalTraffic, 'MB', 'GB', true)
                    )
            }}
            <v-row no-gutters>
              <li class="ml-8 mt-2">
                {{ $t('message.pages.usageLimitModal.cardText4') }}
              </li>
              <span
                class="mt-2 ml-1"
                v-if="
                  preTrafficPrice && currencyLocale && currency && !isFetching
                "
              >
                {{
                  (preTrafficPrice / 100).toLocaleString(currencyLocale, {
                    style: 'currency',
                    currency: currency,
                  })
                }}
              </span>
              <v-skeleton-loader
                v-else
                class="mt-2 ml-1 rounded"
                type="chip"
                height="20"
                width="40"
                tile
              ></v-skeleton-loader>
            </v-row>
            <v-row no-gutters>
              <li class="ml-8 mb-2 mt-1">
                {{ $t('message.pages.usageLimitModal.cardText5') }}
              </li>
              <span
                class="mb-2 mt-1 ml-1"
                v-if="
                  posTrafficPrice && currencyLocale && currency && !isFetching
                "
              >
                {{
                  (posTrafficPrice / 100).toLocaleString(currencyLocale, {
                    style: 'currency',
                    currency: currency,
                  })
                }}
              </span>
              <v-skeleton-loader
                v-else
                class="mb-2 mt-1 ml-1 rounded"
                type="chip"
                height="20"
                width="40"
                tile
              ></v-skeleton-loader>
            </v-row>
            <p
              class="ma-0 inline"
              v-html="
                $t('message.pages.usageLimitModal.cardText6').replace(
                  'XXX',
                  endDate
                )
              "
            ></p>
            <br /><br />
            {{ $t('message.pages.usageLimitModal.cardText8') }} <br />
          </span>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="mr-1"
            @click="handleActivePosPaidTraffic"
            :loading="activePospaidFetching"
            :disabled="!isRootUser"
          >
            <span class="mx-3" v-if="type === 'traffic'">
              <v-row no-gutters
                >{{ $t('message.pages.usageLimitModal.cardAction1') }}
                <span
                  v-if="
                    posTrafficPrice && currencyLocale && currency && !isFetching
                  "
                >
                  {{
                    (posTrafficPrice / 100).toLocaleString(currencyLocale, {
                      style: 'currency',
                      currency: currency,
                    })
                  }}/GB</span
                >
                <v-skeleton-loader
                  v-else
                  class="rounded"
                  type="chip"
                  height="17"
                  width="37"
                  tile
                ></v-skeleton-loader>
              </v-row>
            </span>
            <span v-else class="mx-6">{{ $t('message.cancel') }}</span>
          </v-btn>
          <v-btn
            class="primary white--text"
            min-width="150px"
            text
            :disabled="!isRootUser"
            @click="handleUpgrade"
          >
            <span class="mx-3">
              <v-row no-gutters
                >{{ $t('message.pages.usageLimitModal.cardAction2') }}
                <span
                  v-if="
                    preTrafficPrice && currencyLocale && currency && !isFetching
                  "
                  >{{
                    type === 'traffic'
                      ? (preTrafficPrice / 100).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })
                      : (preStoragePrice / 100).toLocaleString(currencyLocale, {
                          style: 'currency',
                          currency: currency,
                        })
                  }}/GB
                </span>
                <v-skeleton-loader
                  v-else
                  class="rounded"
                  type="chip"
                  height="17"
                  width="33"
                  tile
                ></v-skeleton-loader>
              </v-row>
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// external imports
import { mapMutations, mapState } from 'vuex'
import prettyBytes from 'pretty-bytes'
import _ from 'lodash'

// internal imports
import calcMegabytesMixin from '@/utils/calcMegabytes.js'
import linkHelper from '@/utils/linkHelper.mixin.js'

// API
import planApi from '@/services/planApi'

// Components

export default {
  name: 'UsageLimitModal',
  components: {},
  mixins: [calcMegabytesMixin, linkHelper],
  data: () => ({
    open: false,
    type: 'traffic',
    addons: [],
    preTrafficPrice: 0,
    posTrafficPrice: 0,
    preStoragePrice: 0,
    endTimestampDate: 0,
    isFetching: false,
    currency: null,
    currencyLocale: null,
    activePospaidFetching: false,
    hasPosPaidTraffic: false,
    posPaidTrafficAddonValue: null,
  }),
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    isRootUser() {
      return this.$store.state.user?.userAllInfo?.is_root ?? false
    },
    endDate() {
      return (
        new Date(this.endTimestampDate).toLocaleString('pt-BR').slice(0, 3) +
        new Date(this.endTimestampDate)
          .toLocaleString(this.getLocale(), { month: 'long' })
          .slice(0, 3)
          .toUpperCase() +
        '/' +
        new Date(this.endTimestampDate).toLocaleString('pt-BR').slice(6, 10)
      )
    },
    totalTraffic() {
      if (this.userPlanInfo.limit) {
        return this.userPlanInfo.limit.traffic_plan
      } else {
        return 0
      }
    },
    usedTraffic() {
      if (this.userPlanInfo.limit?.traffic) {
        return this.userPlanInfo.limit.traffic
      } else {
        return 0
      }
    },
    totalStorage() {
      if (this.userPlanInfo.limit?.storage_plan) {
        return this.userPlanInfo.limit.storage_plan
      } else {
        return 0
      }
    },
  },
  mounted() {
    this.$root.$on('usageLimitModal', async (data) => {
      this.$root.$emit('fixUserLimit')
      Object.assign(this.$data, this.initialState())
      this.setCurrencyConfig()
      this.endTimestampDate =
        this.userPlanInfo.subscription.current_period_end * 1000
      this.open = data.open
      this.type = data.type
      this.isFetching = true
      if (this.type === 'traffic') {
        this.checkIfHasPosPaidTraffic()
      }
      await this.getProducts()
      this.getTrafficPrices()
      this.isFetching = false
    })
  },
  beforeDestroy() {
    this.$root.$off('usageLimitModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_ONLY_CUSTOMIZING']),
    checkIfHasPosPaidTraffic() {
      let trafficAddons = this.userPlanInfo?.addons?.traffic
      if (trafficAddons) {
        for (let trafficAddon of trafficAddons) {
          if (
            trafficAddon.type === 'traffic' &&
            trafficAddon.charge === 'pos'
          ) {
            this.hasPosPaidTraffic = true
            if (trafficAddon.quantity > 999) {
              this.posPaidTrafficAddonValue = this.calcMegabytes(
                trafficAddon.quantity,
                'GB',
                'TB',
                true
              )
            } else {
              this.posPaidTrafficAddonValue = `${trafficAddon.quantity} GB`
            }
          }
        }
      }
    },

    async handleActivePosPaidTraffic() {
      this.activePospaidFetching = true
      try {
        await planApi.activePosCharge()
        this.handleClose()
        this.$root.$emit('refreshUserPlan')
      } catch (e) {
        console.error(e)
      }
      this.activePospaidFetching = false
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.currency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    getTrafficPrices() {
      if (this.userPlanInfo.subscription !== null) {
        let userAddons = this.userPlanInfo.addons
        if (userAddons.traffic) {
          let prePlan = this.userPlanInfo.addons.traffic.find(
            (el) => el.charge === 'pre'
          )
          if (prePlan) {
            this.preTrafficPrice = prePlan.unit_amount
          }
          let posPlan = this.userPlanInfo.addons.traffic.find(
            (el) => el.charge === 'pos'
          )
          if (posPlan) {
            const found = this.findAddon({ charge: 'pos', type: 'traffic' })

            this.posTrafficPrice = found
              ? found.unit_amount
              : posPlan.unit_amount
          }
        }
        if (userAddons.storage) {
          let prePlan = this.userPlanInfo.addons.storage.find(
            (el) => el.charge === 'pre'
          )
          if (prePlan) {
            this.preStoragePrice = prePlan.unit_amount
          }
        }
      }
      for (let i = 0; i < this.addons.length; i++) {
        let addon = this.addons[i]
        if (
          addon.metadata.type === 'traffic' &&
          addon.metadata.charge === 'pre' &&
          this.preTrafficPrice < 1
        ) {
          this.preTrafficPrice = addon.prices[0].unit_amount
        }
        if (
          addon.metadata.type === 'traffic' &&
          addon.metadata.charge === 'pos' &&
          this.posTrafficPrice < 1
        ) {
          const found = this.findAddon({ charge: 'pos', type: 'traffic' })

          this.posTrafficPrice = found
            ? found.unit_amount
            : addon.prices[0].unit_amount
        }
        if (
          addon.metadata.type === 'storage' &&
          addon.metadata.charge === 'pre'
        ) {
          this.preStoragePrice = addon.prices[0].unit_amount
        }
      }
    },
    async getProducts() {
      try {
        const currency = this.userPlanInfo.currency ?? this.currency
        const ret = await planApi.getPlans(currency)
        this.addons = ret.data.addons
      } catch (e) {
        setTimeout(() => {
          this.getProducts()
        }, 200)
      }
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    handleClose() {
      this.open = false
    },
    handleUpgrade() {
      this.UPDATE_ONLY_CUSTOMIZING(true)
      this.$router.push({ name: 'Cart' })
      this.handleClose()
    },
    calcBytes(plan) {
      const bytes = plan * 1e9
      return `${prettyBytes(bytes, { maximumFractionDigits: 0 })}`
    },
    openHelpTrafficPage() {
      let link = this.getTrafficLink()
      window.open(`${link}`, '_blank')
    },
    initialState() {
      return {
        open: false,
        type: 'traffic',
        addons: [],
        preTrafficPrice: 0,
        posTrafficPrice: 0,
        endTimestampDate: 0,
        isFetching: false,
      }
    },
    findAddon({ charge, type }) {
      return _.find(this.userPlanInfo.addons.traffic, { charge, type })
    },
  },
}
</script>

<style lang="scss">
.inline {
  display: inline;
}
</style>
